import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { AppDispatch, AppGetState } from '@/store'

import type * as Types from './types'
import type { RefundSearchReqDTO, RefundSearchRes, RefundSearchRespDTO, SearchFormTypes } from '@/services/api/refund/type'
import { CUSTOM_ADDRESS } from '@/containers/Refund/List/component/SearchForm/RefundAddressType'
import { refundSearch } from '@/services/api/refund'

const initialState: Types.IInitialState = {
  pagination: {
    current: 1,
    pageSize: 25,
    total: 0,
  },
  list: [],
  loading: false,
  activeTab: 'pending',
  selectedRows: [],
  hasSearch: false,
  searchParams: {},
  qtyStat: {},
}

const refundSlice = createSlice({
  name: 'refund',
  initialState: initialState,
  reducers: {
    setPagination(state, action: PayloadAction<Types.IPagination>) {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      }
    },
    setList(state, action: PayloadAction<any>) {
      return {
        ...state,
        list: action.payload,
      }
    },
    setLoading(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        loading: action.payload,
      }
    },
    setActiveTab(state, action: PayloadAction<Types.ITabsType>) {
      return {
        ...state,
        activeTab: action.payload,
      }
    },
    setQtyStat(state, action: PayloadAction<any>) {
      return {
        ...state,
        qtyStat: action.payload,
      }
    },
    setSelectedRows(state, action: PayloadAction<RefundSearchRespDTO[]>) {
      return {
        ...state,
        selectedRows: action.payload,
      }
    },
    setHasSearch(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        hasSearch: action.payload,
      }
    },
    setSearchParams(state, action: PayloadAction<SearchFormTypes>) {
      return {
        ...state,
        searchParams: action.payload,
      }
    },
  },
})

export const { setPagination, setQtyStat, setList, setLoading, setActiveTab, setSelectedRows, setHasSearch, setSearchParams } = refundSlice.actions

//1212

const formatListParams = (params: SearchFormTypes, state: Types.IInitialState): RefundSearchReqDTO => {
  const {
    dateGroupRange,
    selectType,
    searchValue,
    batchSearch,
    logisticsIds,
    logisticsStatusList,
    inboundMainStatusList,
    refundAddressType,
    customLogisticsName,
    failReason,
    refundType,
    orderSourceTypes,
  } = params
  let _orderParams = {}
  if (searchValue) {
    _orderParams = {
      key: selectType,
      values: [searchValue],
    }
  } else if (batchSearch) {
    _orderParams = {
      key: batchSearch.key,
      values: batchSearch.values,
    }
  }

  const _refundAddressParams = {
    warehouseIds: refundAddressType?.filter((i) => i !== CUSTOM_ADDRESS),
    consigneeTypeCustom: refundAddressType ? refundAddressType?.findIndex((i) => i === CUSTOM_ADDRESS) !== -1 : undefined,
  }

  return {
    ..._orderParams,
    ..._refundAddressParams,
    pageNum: state.pagination.current,
    pageSize: state.pagination.pageSize,
    customLogisticsName,
    failReason,
    logisticsIds,
    logisticsStatusList,
    inboundMainStatusList,
    mainStatusList: state.activeTab === 'all' ? undefined : [state.activeTab],
    createStartTime: dateGroupRange ? new Date(dateGroupRange[0]).getTime() : undefined,
    createEndTime: dateGroupRange ? new Date(dateGroupRange[1]).getTime() : undefined,
    refundType,
    orderSourceTypes,
  } as RefundSearchReqDTO
}
// 获取退货列表
export const getrefundList = (params: SearchFormTypes) => async (dispatch: AppDispatch, getState: AppGetState) => {
  dispatch(setLoading(true))
  const { refund: state } = getState()
  const _params = formatListParams(params, state)
  const resp = await refundSearch(_params)
  dispatch(setList(resp.data.list))
  dispatch(setQtyStat(resp.data.qtyStat))
  dispatch(setSearchParams(_params))
  dispatch(
    setPagination({
      current: resp.data.pageNum,
      pageSize: resp.data.pageSize,
      total: resp.data.total,
    })
  )
  dispatch(setLoading(false))
  return resp.data as RefundSearchRes
}

export default refundSlice.reducer
